import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import containerActions from '../../actions';

import active from './img/ACTIVE.png';
import hide from './img/hide.png';
import del from './img/delete.png';
import plusB from './img/plus_b.svg';
import plusW from './img/plus_w.svg';
import './styles.scss';

class CarsActiveMenu extends Component {
  constructor () {
    super();
    this.state = {
      showModalDeleteCar: false
    };
  }
  openAddCaraPage = () => {
    this.props.SetActionPage('addCar');
  }
  showModal = () => {
    this.setState({
      showModalDeleteCar: !this.state.showModalDeleteCar
    });
  }
  confirmDelete = () => {
    this.props.deleteCarsReq();
    this.showModal();
  }
  render() {
    return (
      <div className="body-menuActiveCars">
        <button className="button-carsActiveMenu -addCar" onClick={this.openAddCaraPage}>
          <img src={plusW} alt="plusW_pic" />
          <span>ADD CAR</span>
        </button>
        <button className="button-carsActiveMenu -Importlist">
          <img src={plusB} alt="plusB_pic" />
          <span>IMPORT LIST</span>
        </button>
        <div className="button-carsActiveMenu -InLine">
          <img src={active} alt="" />
          <button className="-disabled">ENABLE</button>
        </div>
        <div className="button-carsActiveMenu -InLine">
          <img src={hide} alt="" />
          <button className="-disabled">HIDE</button>
        </div>
        <div className="button-carsActiveMenu -InLine">
          <img src={del} alt="" />
          <button
            className={this.props.disFunBut ? 'but' : 'disabled'}
            onClick={this.showModal}
            disabled={!this.props.disFunBut}
          >DELETE
          </button>
        </div>
        {this.state.showModalDeleteCar &&
          <div className="modalDel-carsActiveMenu">
            <div className="modalForm-carsActiveMenu">
              <div>You want to delete ({this.props.delRowCount}) row(s)?</div>
              <button onClick={this.confirmDelete}>YES</button>
              <button onClick={this.showModal}>NO</button>
            </div>
          </div>
        }
      </div>
    );
  }
}

CarsActiveMenu.propTypes = {
  SetActionPage: PropTypes.func.isRequired,
  deleteCarsReq: PropTypes.func.isRequired,
  delRowCount: PropTypes.number.isRequired,
  disFunBut: PropTypes.bool.isRequired
};
const mapStateToProps = () => ({
});
export default connect(mapStateToProps, containerActions)(CarsActiveMenu);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/carActiveMenu/index.js